import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Reports from './pages/Reports';

function App() {
  return (
    <>
      <Router basename={'/Depression-Detection'}>
        <Navbar />
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/SentimentAnalysis' component={Reports} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
